import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { API_ADDRESS, httpOptionsDefault } from "../constants";



export class LicensesController {


    constructor(public _http: HttpClient) {
    }
    getExpirations(start, length, month,
        year, productId, vendorId, companyID,
        status): Promise<any> {


         return this._http.get(API_ADDRESS + `/licenses/expirations/${start}/${length}/${month}/${year}/${productId}/${vendorId}/${companyID}/${status}`, httpOptionsDefault)
            .pipe(
                map(result => {


                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any[]) => {


                return result;
            });

    }

      allLicenses(start, length, month,
        year, productId, vendorId, companyID,
        status): Promise<any> {


         return this._http.get(API_ADDRESS + `/licenses/select/${start}/${length}/${month}/${year}/${productId}/${vendorId}/${companyID}/${status}`, httpOptionsDefault)
            .pipe(
                map(result => {0


                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any[]) => {


                return result;
            });

    }

}
